module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e4Dx1"))).then(() => parcelRequire('9Lwss'));